import { Familia, TipoDomicilioEnum, TipoImovelEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { AnimaisImovelFormModel } from 'view/cadastro-imovel/model-cadastroImovel'
import { CidadaoTerritorioBasicoWithProntuarioId } from 'view/visualizacao-imovel/model-visualizacao-imovel'

import { domicilioTipoImovelRecord, TipoImovelListModel, tipoImovelRecord } from '../model'

export const getTipoImovelIcon = (tipoImovel: TipoImovelEnum, tipoDomicilioId: string): TipoImovelListModel => {
  if (!isUndefinedOrNull(tipoImovel)) {
    if (tipoImovel !== TipoImovelEnum.DOMICILIO) {
      return tipoImovelRecord[tipoImovel]
    }
    if (!isUndefinedOrNull(tipoDomicilioId)) {
      return domicilioTipoImovelRecord[tipoDomicilioId]
    } else {
      return domicilioTipoImovelRecord[TipoDomicilioEnum.CASA]
    }
  }
  return tipoImovelRecord[TipoImovelEnum.OUTROS]
}

export const getResponsavelDependentesFamilia = (
  familia: Pick<Familia, 'cpfCnsResponsavel'> & {
    cidadaosTerritorioBasico: ReadonlyArray<CidadaoTerritorioBasicoWithProntuarioId>
  }
) => {
  return familia.cidadaosTerritorioBasico.reduce<{
    responsavel: CidadaoTerritorioBasicoWithProntuarioId | null
    dependentes: CidadaoTerritorioBasicoWithProntuarioId[]
  }>(
    (acc, cidadao) => {
      if (
        (cidadao.cpf && cidadao.cpf === familia.cpfCnsResponsavel) ||
        (cidadao.cns && cidadao.cns === familia.cpfCnsResponsavel)
      ) {
        acc.responsavel = cidadao
      } else {
        acc.dependentes.push(cidadao)
      }

      return acc
    },
    { responsavel: null, dependentes: [] }
  )
}

export const getTiposAnimaisStringListCapitalized = (animaisImovel: AnimaisImovelFormModel) => {
  const list = [
    animaisImovel.possuiCachorro ? 'Cachorro' : null,
    animaisImovel.possuiGato ? 'Gato' : null,
    animaisImovel.possuiPassaro ? 'Pássaro' : null,
    animaisImovel.possuiGalinha ? 'Galinha' : null,
    animaisImovel.possuiPorco ? 'Porco' : null,
    animaisImovel.possuiMacaco ? 'Macaco' : null,
    animaisImovel.possuiRepteis ? 'Répteis' : null,
    animaisImovel.possuiOutros ? 'Outros' : null,
  ].filterNotNull()

  return list?.isNotEmpty() ? list : null
}
